import React, { useState } from "react";
import { useAuth } from "../../../providers/AuthContext";
import { USER_ACTIONS, USER_NAV } from "../../../routes/APP_ROUTES";
import { Tab, TabGroup, TabList } from "@headlessui/react";
import { ReactComponent as IconLogout } from "../../../assets/icons/icon-us-logout.svg";
import { useNavigate, useLocation, Outlet, NavLink } from "react-router-dom";

const AccountSettings = () => {
  const { user, logout } = useAuth();
  const userNav = USER_NAV()
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="max-w-[70rem] mx-auto flex items-start my-5">
      <ul className="max-w-[25%] flex-auto md:block hidden">
        <div className="bg-[#313346] p-4 rounded-ss-xl rounded-es-xl">
          {userNav.map((item, index) => (
            <NavLink
              key={index}
              type="button"
              className={`bg-[#46485c] cursor-pointer w-full flex items-center gap-2 hover:bg-primary text-lg font-semibold px-4 py-2 text-white  [&_svg]:w-[18px] [&_svg]:h-[22px] border-b border-[#313346] ${
                location.pathname === `/user/${item.path}` ? "!bg-primary " : ""
              }`}
              to={`/user/` + item.path}
            >
              {item.icon}
              {item.label}
            </NavLink>
          ))}

          {/* <div className="mt-2 border-t border-white border-opacity-10 pt-2">
            <button
              className="w-full rounded-md flex items-center gap-2 hover:bg-primary hover:text-black text-lg font-semibold px-4 py-2 text-white [&_svg_path]:hover:fill-black [&_svg]:w-[22px] [&_svg]:h-[22px]"
              onClick={logout}
            >
              <IconLogout />
              <span className="text-lg">Logout</span>
            </button>
          </div> */}
        </div>
      </ul>

      {/* Outlet for Nested Routes */}
      <div className="w-full px-5 py-4 bg-[#313346] md:rounded-none rounded-xl max-w-screen-md">
        <Outlet />
      </div>
    </div>
  );
};

export default AccountSettings;
